// @core/api/endpoints/apikey/list_scopes.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListScopesResponse,
} from '../../../types/apikey';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/apikey';

/**
 * List available scopes
 * Deprecated: use ListPermissions. Returns all available API scopes that can be assigned to API keys.
 * @public This endpoint does not require authentication
 */
export async function ListScopes(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListScopesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/api-keys/scopes`;
  const requestOptions = { ...options, skipAuth: true };
  return client.get<ListScopesResponse>(requestPath, { ...requestOptions, params });
}
